export default __webpack_public_path__ + "static/media/user_3.f1aa4dac.png";